export default __webpack_public_path__ + "static/media/Favicon_Yesmindy.f989e255.png";